import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllKras, getSkillAndWllUserSpecific } from '../../../../../../redux/features/appraisalSlice';
import SkillsCard from './SkillsCard';
import { Box } from '@mui/material';
import PaginationComponent from '../../../../../appraisal/goalManagement/PaginationComponent';
import NoDataFound from '../../../../../../components/NodataIndication/NoDataFound';
import MotionWrapper from '../../../../../../components/MotionWrapper';
import LoadingSkeleton from '../../../golas/TeamGoals/LoadingSkelton';
import DeleteSkills from './DeleteSkills';
import TagSkills from './tagSkills';

const SkillsUserSpecific = ({ user, induvidualView }) => {
  const dispatch = useDispatch();
  const { skillAndWllUserSpecificData, loading } = useSelector((state) => state.appraisal);
  const [open, setOpen] = useState(false);
  const data = {
    type: 'skills',
    userTypeId: '',
    userId: user?.userID || '',
  };

  const [selectedSkill, setSelectedSkill] = useState(null);
  const [dispatchNew, setDiapatchNew] = useState(false);

  const handleDeletePopup = (skill) => {
    setSelectedSkill(skill);
    setOpen(true);
  };
  useEffect(() => {
    const data = { type: 'skills', search: '' };
    dispatch(getAllKras(data));
  }, []);
  return (
    <Box>
      {!induvidualView && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pb: 1 }}>
          <TagSkills userId={user?.userID || ''} update={setDiapatchNew} />
        </Box>
      )}

      {loading ? (
        <LoadingSkeleton />
      ) : (
        <>
          {Array.isArray(skillAndWllUserSpecificData?.data) && skillAndWllUserSpecificData.data.length > 0 ? (
            skillAndWllUserSpecificData.data.map((item, i) => (
              <Box key={item.sl_no}>
                <MotionWrapper direction={'top'} delay={i * 0.1}>
                  <SkillsCard handleDeletePopup={handleDeletePopup} data={item} induvidualView={induvidualView} />
                </MotionWrapper>
              </Box>
            ))
          ) : (
            <NoDataFound />
          )}
        </>
      )}

      <Box>
        <Box pt={2}>
          <PaginationComponent
            api={getSkillAndWllUserSpecific}
            otherProps={data}
            loading={loading}
            dependencyFields={[dispatchNew]}
            meta={skillAndWllUserSpecificData.meta}
          />
        </Box>
      </Box>
      <DeleteSkills open={open} setOpen={setOpen} skill={selectedSkill} setDispatchNew={setDiapatchNew} />
    </Box>
  );
};

export default SkillsUserSpecific;
